import { ViewPaneHeaderProps } from 'appLayout/ardoqStudio/types';
import { OptionsGroup } from '@ardoq/settings-bar';
import { ViewContext } from '@ardoq/view-settings';
import { connect } from '@ardoq/rxbeach';
import { viewModifiers$ } from './viewModifiers$';
import { viewActionsOptions } from './viewActionsOptions';
import { filter } from 'rxjs';
import { FlexBox } from '@ardoq/layout';
import type { I18nLocale } from '@ardoq/i18n';

type ViewPaneHeaderLeftControlsProps = ViewPaneHeaderProps & {
  viewContext: ViewContext;
  viewProperties: Record<string, any>;
  i18nLocale: I18nLocale;
};

const ViewPaneHeaderLeftControls = ({
  mainViewId,
  viewProperties,
  viewContext,
  i18nLocale,
}: ViewPaneHeaderLeftControlsProps) => (
  <FlexBox gap="xsmall" align="center">
    <OptionsGroup
      viewId={mainViewId}
      options={viewActionsOptions(
        mainViewId,
        viewProperties,
        viewContext,
        i18nLocale
      )}
      isViewpointModeViewPaneHeader={true}
      i18nLocale={i18nLocale}
    />
  </FlexBox>
);
const ConnectedViewPaneHeaderLeftControls = connect(
  ViewPaneHeaderLeftControls,
  viewModifiers$.pipe(
    filter(
      ({ mainViewId, viewPropertiesViewId }) =>
        mainViewId === viewPropertiesViewId
    )
  )
);

export { ConnectedViewPaneHeaderLeftControls };
